import { render } from "./SendMail.vue?vue&type=template&id=88d7e2a8"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "./SendMail.vue?vue&type=style&index=0&id=88d7e2a8&lang=scss"
import "./SendMail.vue?vue&type=style&index=1&id=88d7e2a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__